import React from "react";
import { Dropdown, DropdownButton, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs } from "@fortawesome/free-solid-svg-icons";

class ExaminationFilesActionCell extends React.PureComponent {
  constructor(props) {
    super(props);
    this.showShare = this.showShare.bind(this);
    this.showStopSharing = this.showStopSharing.bind(this);
    this.isDropdownDisabled = this.isDropdownDisabled.bind(this);
  }

  showShare() {
    //  Not shared (0) && exam status ready (1), prepared (50), allocating (51, 52, 53)
    return (
      this.props.file.sharingStatus === 0 &&
      (this.props.examinationStatus === 1 ||
        (this.props.examinationStatus >= 50 &&
          this.props.examinationStatus <= 53))
    );
  }

  showStopSharing() {
    // Shared (2) && exam status ready (1), prepared (50), allocating (51, 52, 53)
    return (
      this.props.file.sharingStatus === 2 &&
      (this.props.examinationStatus === 1 ||
        (this.props.examinationStatus >= 50 &&
          this.props.examinationStatus <= 53))
    );
  }

  isDropdownDisabled() {
    // exam status ready (1), prepared (50), allocating (51, 52, 53)
    return (
      (this.props.examinationStatus !== 1 &&
        !(
          this.props.examinationStatus >= 50 &&
          this.props.examinationStatus <= 53
        )) ||
      this.props.file.sharingStatus === 1 ||
      this.props.file.sharingStatus === 3
    );
  }

  render() {
    const { t } = this.props;
    return (
      <Row style={{ marginLeft: "-3px", float: "right" }}>
        <div style={{}}>
          <DropdownButton
            size="sm"
            onClick={event => event.stopPropagation()}
            id="dropdown-basic-button"
            title={<FontAwesomeIcon icon={faCogs} />}
            className="btn-green"
            disabled={this.isDropdownDisabled()}
          >
            {this.showShare() && (
              <Dropdown.Item onClick={this.props.onShare}>
                {t(
                  "SingleExamination.ExaminationFilesTab.ActionCell.ShareOption"
                )}
              </Dropdown.Item>
            )}
            {this.showStopSharing() && (
              <Dropdown.Item onClick={this.props.onStopSharing}>
                {t(
                  "SingleExamination.ExaminationFilesTab.ActionCell.StopSharingOption"
                )}
              </Dropdown.Item>
            )}
            <Dropdown.Item onClick={this.props.onDownload}>
              {t(
                  "SingleExamination.ExaminationFilesTab.ActionCell.DownloadOption"
              )}
            </Dropdown.Item>
            <Dropdown.Item onClick={this.props.onDelete}>
              {t(
                "SingleExamination.ExaminationFilesTab.ActionCell.DeleteOption"
              )}
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </Row>
    );
  }
}

export default withTranslation()(ExaminationFilesActionCell);
